import { PACKAGE_NAME, isProd } from '@remote/api/config'
export const useVConsole = () => {
  let count = 0
  let isEnabled = false

  const enable = () => {
    if (!isEnabled) {
      const head = document.getElementsByTagName('head')[0]
      const script = document.createElement('script')
      script.type= 'text/javascript'
      script.onload = function () {
        // @ts-ignore
        new VConsole()
        isEnabled = true
        localStorage.setItem('vc', 'enabled')
      }
      script.src = `https://${PACKAGE_NAME}/yc/js/vconsole.js`
      head.appendChild(script)
    }
  }

  const enableClick = () => {
    count++
    if (count > 20) {
      enable()
    }
  }

  const check = () => {
    if (localStorage.getItem('vc') === 'enabled' || !isProd) {
      enable()
    }
  }
  
  return {
    check,
    enableClick,
  }
}